import { render, staticRenderFns } from "./user_pwd.vue?vue&type=template&id=43705926&scoped=true"
import script from "./user_pwd.vue?vue&type=script&lang=js"
export * from "./user_pwd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43705926",
  null
  
)

export default component.exports